module.exports = __webpack_public_path__ + "img/1.eb939fc5.png";